import * as React from "react";
const SvgTagFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M16.5 17a2 2 0 0 0 1.6-.8l2.7-3.6a1 1 0 0 0 0-1.2l-2.7-3.6a2 2 0 0 0-1.6-.8H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2z", clipRule: "evenodd" }));
export default SvgTagFill;
